import React from "react";
import AdScrollRefresh from "./AdScrollRefresh";
import cx from "classnames";
import Cookies from "js-cookie";
import sty from "./adIframe.module.less";

interface IProps {
  className?: any;
  slot: string;
  refresh?: boolean;
  isReload?: boolean;
  size: [number[] | string[], number[] | string[]] | [number[] | string[]];
  styles?: React.CSSProperties;
  children?: React.ReactNode;
  callBack?: (event: {}) => void;
  target?: string[];
}

interface IState {
  data: any;
  isEmpty: boolean;
}

const setTarget = (googletag: any) => {
  googletag.pubads().enableSingleRequest();
  googletag.enableServices();
};
class AdIframe extends React.PureComponent<IProps, IState> {
  static defaultProps = {
    isReload: false,
  };
  readonly state: IState = {
    data: {},
    isEmpty: true,
  };
  componentDidMount() {
    const { slot, size, target } = this.props;

    window.googletag.cmd.push(() => {
      window.googletag.pubads().addEventListener("slotRenderEnded", this.slotRenderEnded.bind(this));
      window.googletag.defineSlot(slot, size, slot).addService(window.googletag.pubads());

      setTarget(window.googletag);

      const buycar_stage = localStorage.getItem("buycar_stage");
      window.googletag.pubads().setTargeting("buycar_stage", buycar_stage);

      if (Cookies.get("appversion") == "debug" || Cookies.get("adtest") == "true") {
        window.googletag.pubads().setTargeting("debug", "1");
      }
      if (target) {
        window.googletag.pubads().setTargeting(target[0], target[1]);
      }

      window.googletag.display(slot);
    });
  }

  private slotRenderEnded = (event: any) => {
    const { slot, isReload, callBack } = this.props;
    const { data } = this.state;

    const isSlot = event.slot.getAdUnitPath() === slot;
    if (!isSlot) {
      return;
    }
    let isData = Object.keys(data).length === 0;
    if (!event.isEmpty && (isReload || isData)) {
      let _html = event.slot.getHtml();
      let _event = {};

      try {
        const regex = /\<\!---(.+?)---\>/g;
        const content = regex.exec(_html);
        if (content) {
          _event = JSON.parse(content[1]);
          this.setState({
            data: _event,
            isEmpty: false,
          });
          callBack && callBack(_event);
        }
      } catch (e) {
        this.setState({
          isEmpty: false,
        });
        callBack && callBack(_event);
      }
    }
  };

  render() {
    const { data, isEmpty } = this.state;
    const { slot, styles, children, refresh, className } = this.props;

    return (
      <AdScrollRefresh slot={slot} refresh={refresh}>
        <>
          <div
            className={cx(sty["ad-iframe"], {
              [className]: !!className,
            })}
            id={slot}
            style={{ ...styles, display: isEmpty ? "none" : "" }}
          />
          {React.isValidElement(children) && React.cloneElement(children, { data: data })}
        </>
      </AdScrollRefresh>
    );
  }
}

export default AdIframe;
